import { ArithmeticException } from '@zxing/library'
import { InvitationAPI } from './types'

export const invitationApi: InvitationAPI = ky => {
  return {
    async create({ payload }) {
      return await ky(`invitation/`, {
        method: 'post',
        body: JSON.stringify(payload)
      }).json()
    },

    async accept({ invitationId, payload }) {
      return await ky(`invitation/${invitationId}/accept/`, {
        method: 'put',
        body: JSON.stringify(payload)
      }).json()
    },

    async acceptPatient({ invitationId, payload }) {
      return await ky(`patient/invitation/${invitationId}/`, {
        method: 'put',
        body: JSON.stringify(payload)
      }).json()
    }
  }
}
